import { translateFunc } from "client/utils/translateFunc";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { deleteTextBox } from "store/features/memeGenerator/actions";
import { useAppDispatch } from "store/store";

interface DeleteProps {
    textBoxId: string;
}

export const Delete = ({ textBoxId }: DeleteProps) => {
    const dispatch = useAppDispatch();
    function onClick() {
        dispatch(deleteTextBox(textBoxId));
    }
    return (
        <ToolTip text={translateFunc("delete-text-box")}>
            <button
                className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                onClick={onClick}
            >
                <DeleteIcon className="fill-irRed-400" />
            </button>
        </ToolTip>
    );
};
